import { ActionType } from "../../../../react-core/Flux/ActionType";
import { AdviserReadWritePermissionClient } from "../../../../Wrap/Api/User/AdviserReadWritePermission";
import { AdviserReadWritePermissionByAccountClient } from "../../../../Wrap/Api/User/AdviserReadWritePermissionByAccount";
import { AspxPagePermissionClient } from "../../../../Wrap/Api/User/AspxPagePermission";
import { UserAllowedClaimsClient } from "../../../../Wrap/Api/User/UserAllowedClaims";
import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";
import { AdviserReadWritePermissionModel } from "../../../../Wrap/Models/Domains/Users/AdviserReadWritePermissionModel";
import { AspxPagePermissionModel } from "../../../../Wrap/Models/Domains/Users/AspxPagePermissionModel";
import { PerformanceDataView } from "../../../Dashboard/Components/Clients/PortfolioDashboard/Components/Performance/Resource/Contents";
import { TransactionEnum } from "../../../Dashboard/Components/Clients/PortfolioDashboard/Components/Transactions/Resource/Contents";
import { PermissionDisaptcher, PermissionStore } from "../Store/Variables";

export class PermissionAction {
    public static getPermissionByClaim() {
        if (PermissionStore.getData() || PermissionStore.isLoading()) {
            return;
        }
        PermissionDisaptcher.dispatch({ actionType: ActionType.Loading, payload: [] });
        const client = new UserAllowedClaimsClient();
        const promise = client.get();
        promise.onSuccess((result) => {
            PermissionDisaptcher.dispatch({ actionType: ActionType.Success, payload: result?.AllowedClaims });
        });
    }

    public static getPerformancePermissionMap() {
        return {
            [PerformanceDataView.Summary]: UserClaim.AdviserPortalPerformanceSummaryCanView,
            [PerformanceDataView.Detail]: UserClaim.AdviserPortalPerformanceDetailCanView,
            [PerformanceDataView.RealisedGainLoss]: UserClaim.AdviserPortalRealisedGainLossCanView,
            [PerformanceDataView.UnrealisedGainLoss]: UserClaim.AdviserPortalUnrealisedGainLossCanView,
            [PerformanceDataView.Income]: UserClaim.AdviserPortalPerformanceIncomeCanView,
            [PerformanceDataView.Charges]: UserClaim.AdviserPortalPerformanceIncomeCanView,
        };
    }

    public static checkUserHavePermissionForAdviserByActor(
        actorId: number,
        callback?: (accounts: AdviserReadWritePermissionModel) => void
    ) {
        const client = new AdviserReadWritePermissionClient();
        const promise = client.get(actorId);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => { });
    }

    public static checkUserHavePermissionForAdviserByAccount(
        hierarchyId: string,
        callback?: (accounts: AdviserReadWritePermissionModel) => void
    ) {
        const client = new AdviserReadWritePermissionByAccountClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => { });
    }
    public static getPermissionForASPXPage(url: string, callBack: (result: AspxPagePermissionModel) => void) {
        const client = new AspxPagePermissionClient();
        const promise = client.post(url);
        promise.onSuccess((result) => {
            callBack(result);
        });
        promise.onError((err) => { });
    }

    public static getTransactionPermissionMap() {
        return {
            [TransactionEnum.summary]: UserClaim.AdviserPortalInvestmentTransactionCanView,
            [TransactionEnum.cash]: UserClaim.AdviserPortalInvestmentTransactionCanView,
            [TransactionEnum.investments]: UserClaim.AdviserPortalInvestmentTransactionCanView,
            [TransactionEnum.paymentsWithdrawals]: UserClaim.AdviserPortalPaymentsAndWithdrawlsCanView,
            [TransactionEnum.accountTransfers]: UserClaim.AdviserPortalAccountTransfersCanView,
            [TransactionEnum.corporateActions]: UserClaim.AdviserPortalDividendSummaryCanView,
            [TransactionEnum.otherCorporateActions]: UserClaim.AdviserPortalOtherCorporateActionsCanView,
            [TransactionEnum.charges]: UserClaim.AdviserPortalPerformanceChargesCanView,
            [TransactionEnum.offPlatformIncome]: UserClaim.AdviserPortalInvestmentTransactionCanView,
        };
    }

    public static getPerformanceDropdownOptions() {
        const options = [];
        const permissionMap = this.getPerformancePermissionMap();
        for (const key in PerformanceDataView) {
            if (PermissionStore.getData().filter((x) => x == permissionMap[PerformanceDataView[key]]) != null) {
                options.push(PerformanceDataView[key]);
            }
        }
        return options;
    }

    public static getTransactionDropdownOptions() {
        const options = [];
        const permissionMap = this.getTransactionPermissionMap();
        for (const key in TransactionEnum) {
            if (PermissionStore.getData().find((x) => x == permissionMap[TransactionEnum[key]]) != null) {
                options.push(TransactionEnum[key]);
            }
        }
        return options;
    }
}
